import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => {
  return {
    resultsText: {
      fontSize: "14px",
      fontWeight: 700,
      margin: "24px 0",
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalContainer: {
      background: "#000",
      color: "#fff",
      width: "490px",
      minHeight: "210px",
      padding: "32px",
      textAlign: "center",
    },
    titleModal: {
      fontSize: "24px",
      fontWeight: 700,
      marginBottom: "16px",
    },
    textodal: {
      fontSize: "14px",
      color: "#C4C4C4",
      fontWeight: 400,
      paddingBottom: '20px'
    },
    inputModal: {
      margin: "24px 0",
      background: "#fff",
      color: "#000",
    },
    btnModal: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      gap: "24px",
      "& button": {
        padding: "16px 24px",
      },
      "& .cancel": {
        background: "#999",
        color: "#666",
      },
    },
    reasonDisapproval: {
      background: '#fff',
      color: '#000',
      margin: '24px',
      width: '90%',
      fontSize: '12px',
      '& input': {
        background: '#fff',
        color: '#000',
      },
    }
  };
});
